
export class OdooException {
  private _message: string;
  private _data: any;
  private _code: number;

  constructor(
    message: string,
    data: any,
    code: number,
  ) {
    this._message = message;
    this._data = data;
    this._code = code;
  }

  static createFromAny(data: any): OdooException {
    if (data === null || data === undefined) {
      return null;
    }

    return new OdooException(
      data.message,
      data.data,
      data.code,
    );
  }

  get message(): string {
    if (this._data && this._data.message) {
      return this._data.message;
    }

    return this._message;
  }

  get code(): number {
    return this._code;
  }

  get data(): any {
    return this._data;
  }

  get isSessionExpired(): boolean {
    return this.code === 100
      && (
        this._message === 'Odoo Session Expired'
        || this._message === 'Odoo Session Invalid'
      );
  }
}
